var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.28223,
    y: 7.70483,
    width: 9.81359,
    height: 0.833333,
    rx: 0.416667,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.28223,
    y: 7.70483,
    width: 9.81359,
    height: 0.833333,
    rx: 0.416667,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.28223,
    y: 11.0415,
    width: 15.0627,
    height: 0.833333,
    rx: 0.416667,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.28223,
    y: 14.3782,
    width: 15.0627,
    height: 0.833333,
    rx: 0.416667,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2.28223,
    y: 17.7146,
    width: 15.0627,
    height: 0.833333,
    rx: 0.416667,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.28223,
    y: 21.051,
    width: 15.0627,
    height: 0.833333,
    rx: 0.416667,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5296 4.57683C17.5296 6.10194 16.162 7.41342 14.3781 7.41342C12.5941 7.41342 11.2265 6.10194 11.2265 4.57683C11.2265 3.05172 12.5941 1.74023 14.3781 1.74023C16.162 1.74023 17.5296 3.05172 17.5296 4.57683Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66202 4.78532V0.69751H18.899V24.7219H0.5V5.28532H6.16202H6.66202V4.78532Z",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 7.68235,
    y2: -0.5,
    transform: "matrix(-0.802101 0.597189 -0.665549 -0.746354 6.16199 0.19751)",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileWhite);
export default __webpack_public_path__ + "static/media/file-white.584987d7db7ef45d689c9dfc04462398.svg";
export { ForwardRef as ReactComponent };